import * as React from 'react'
import styled from 'styled-typed'
import { useParams } from 'react-router'
import { connect } from 'react-redux'
import { RequiresToChangePassword } from 'routesUtils'
import { AppServices } from 'middleware'
import { BaseRouteParams } from 'hocs'
import Header from 'header'
import TopBar from 'header/topBar'
import { PageContent } from './pageContent'
import { State } from 'store'
import Sidebar from 'sidebar'
import { usePermission } from 'admin/hocs'
import { FeatureProps, withFeatures } from 'features'

const Layout = styled.div`
    font-family: ${(props) => props.theme.fonts.primary};
    font-size: 16px;
    color: ${(props) => props.theme.colors.textDark};
    background: ${(props) => props.theme.colors.background};
    padding-left: var(--sidebar-width);
    height: 100%;
    width: 100%;
    flex: 1;
    transition: 0.15s all ease;

    &.fixed {
        position: fixed;
    }

    @media (max-width: ${(props) => props.theme.breakPoints.md}) {
        padding-left: 0;
    }
`

const ContentWrapper = styled.div`
    height: 100%;
`

interface AppShellProps extends FeatureProps {
    activeAccount: string | null
    requiresPasswordChange: boolean
    children?: React.ReactNode
}

const AppShell: React.FC<AppShellProps> = ({ children, requiresPasswordChange, activeAccount, hasFeature }) => {
    const { accountSlug } = useParams<BaseRouteParams>()
    const _slug = accountSlug || activeAccount
    const { hasPermission } = usePermission()

    return (
        <Layout id="layout">
            <Sidebar
                accountSlug={_slug as string}
                hasPermission={hasPermission}
                hasFeature={hasFeature}
                loggingService={AppServices.loggingService}
            />
            <ContentWrapper>
                <Header />
                <TopBar accountSlug={_slug} />
                <PageContent>
                    <RequiresToChangePassword requiresPasswordChange={requiresPasswordChange}>
                        {children}
                    </RequiresToChangePassword>
                </PageContent>
            </ContentWrapper>
        </Layout>
    )
}

const mapStateToProps = (state: State) => {
    return {
        requiresPasswordChange: !!state.profile?.profile?.requiresPasswordChange,
        activeAccount: state.preferences.activeAccount,
    }
}

export default withFeatures(connect(mapStateToProps)(AppShell))
